export class globalConfigs {
  static headers: { [id: string]: any } = {};
  static serializer: string = 'urlencoded';
  static followRedirect: boolean = true;
  static timeout: number = 60.0;
}
